<template>
  <b-container>
    <transition name="fade">
      <div v-if="show">
        <b-row
          class="justify-content-md-center topimage-wrap topimage-wrap-angebote"
        >
          <b-img
            src="https://karlsruher-pass.de/wp-content/uploads/2021/03/Illustrationen-Angebote-8.png"
          />
        </b-row>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="!show">
        <b-row
          class="
            justify-content-md-center
            topimage-wrap topimage-wrap-mitfahren
          "
        >
          <b-img
            width="400"
            src="https://karlsruher-pass.de/wp-content/uploads/2021/01/Mitfahren-8.png"
          />
        </b-row>
      </div>
    </transition>

    <b-row class="justify-content-md-center">
      <b-row class="row-select">
        <b-col cols="10">
          <h4>Gemeinde</h4>
          <Selects
            ref="citySelect"
            :options="optionsCity"
            @selected="getCity"
          />
        </b-col>
      </b-row>
      <b-row class="row-select">
        <b-col cols="10">
          <h4>Kategorie</h4>
          <Selects
            ref="categorySelect"
            :options="optionsCategory"
            @selected="getCategory"
          />
        </b-col>
      </b-row>
      <b-row class="row-select justify-content-md-right">
        <b-col cols="10">
          <h4>Pass</h4>
          <Selects
            ref="passSelect"
            :options="optionsPass"
            @selected="getPass"
          />
        </b-col>
      </b-row>
    </b-row>

    <transition name="fade">
      <div v-if="show">
        <b-row class="justify-content-md-center">
          <b-col>
            <b-col sm="7" md="6" class="col-pagination my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              >
              </b-pagination>
            </b-col>
            <AngTabelle :isBusy="tableIsBusy" :posts="posts" />
            <b-col sm="7" md="6" class="col-pagination my-1"> </b-col>
          </b-col>
        </b-row>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="!show">
        <b-row class="justify-content-md-center" style="margin-top: 70px">
          <b-img
            width="400"
            src="https://karlsruher-pass.de/wp-content/uploads/2021/01/Dein-Ticket-zum-Mitmachen-Key-Visual-8.png"
          />
        </b-row>
      </div>
    </transition>
  </b-container>
</template>

<script>
import Selects from "./Selects";
import AngTabelle from "./AngTabelle";
import axios from "axios";
import _ from "underscore";
import SelectFieldOptions from "../assets/SelectFieldOptions_de.json";

export default {
  data() {
    return {
      show: false,
      tableIsBusy: false,

      totalRows: null,
      perPage: 10,
      totalpages: null,
      currentPage: 1,

      selectedCity: null,
      selectedCategory: null,
      selectedPass: null,

      pageCount: 5,
      posts: [],
      selectedCity: "",
      selectedCategory: "",
      selectedPass: "",

      // parameters for category Rest calls
      allCategories: [],
      categoryPage: 1,
      categoryTotalRows: "",
      categoryTotalPages: "",

      categoriesIDs: [],
      isLoading: false,

      optionsCity: SelectFieldOptions.optionsCity,
      optionsCategory: SelectFieldOptions.optionsCategory,
      optionsPass: SelectFieldOptions.optionsPass,

      backgroundImageDreieckHell:
        "url(/wp-content/uploads/2017/08/Header-1.png)",
      backgroundColorHell: "#fefbe1",
      backgroundImageDreieckHell:
        "url(/wp-content/uploads/2017/08/Header-1.png) !important",
    };
  },

  created() {
    if (
      this.$route.query.city != undefined ||
      this.$route.query.category != undefined ||
      this.$route.query.pass != undefined
    ) {
      this.show = true;
    }
  },

  async mounted() {

    if (this.$route.query.city != undefined) {
      this.$refs.citySelect.preSelect(this.$route.query.city);
    } else {
      if (this.$route.query.category != undefined) {
        this.$refs.categorySelect.preSelect(this.$route.query.category);
      } else {
        if (this.$route.query.pass != undefined) {
          this.$refs.passSelect.preSelect(this.$route.query.pass);
        } else {
        }
      }
    }
  },

  watch: {
    currentPage: function (val) {
      this.fetchPosts();
    },
  },

  methods: {
    getCity(value) {
      this.selectedCity = value;
      this.fetchCategory();
    },

    getCategory(value) {
      this.selectedCategory = value;
      this.fetchCategory();
    },

    getPass(value) {
      this.selectedPass = value;
      this.fetchCategory();
    },

    loadMore() {
      this.currentPage += 1;
      this.fetchPosts();
    },

    async fetchCategory() {
      this.isLoading = true;
      this.tableIsBusy = true;

      this.categoriesIDs = [];
      if (this.selectedCity != "") {
        try {
          const { data } = await axios.get(
            "https://karlsruher-pass.de/wp-json/wp/v2/categories?search=" +
              this.selectedCity
          );
          data.forEach((element) => {
            if (element.slug === this.selectedCity.toLowerCase()) {
              this.categoriesIDs.push(element.id);
            }
            this.isLoading = false;
          });
        } catch (error) {
          throw error;
        }
      }

      if (this.selectedCategory != "") {
        try {
          const { data } = await axios.get(
            "https://karlsruher-pass.de/wp-json/wp/v2/categories?search=" +
              this.selectedCategory
          );
          data.forEach((element) => {
            if (element.slug === this.selectedCategory.toLowerCase()) {
              this.categoriesIDs.push(element.id);
            }
          });
        } catch (error) {
          throw error;
        }
      }
      if (this.selectedPass != "") {
        try {
          const { data } = await axios.get(
            "https://karlsruher-pass.de/wp-json/wp/v2/categories?search=" +
              this.selectedPass
          );
          data.forEach((element) => {
            if (element.slug === this.selectedPass.toLowerCase()) {
              this.categoriesIDs.push(element.id);
            }
          });
        } catch (error) {
          throw error;
        }
      }
      this.fetchPosts();
    },

    async fetchPosts() {
      this.tableIsBusy = true;
      var url;
      this.show = true;
      this.posts = [];

      console.log(this.categoriesIDs)

      // categories_exclude=1734 entfernt alle deutschen Kategorien
      // categories_exclude=1922 entfernt alle englischen Kategorien
      // 1817 information-en
      // 1032 information-de
      if (this.categoriesIDs.length === 0) {
        url = `https://karlsruher-pass.de/wp-json/wp/v2/posts?per_page=${this.perPage}&page=${this.currentPage}&categories_exclude=1922,1817&_embed`;
        //url =  `https://karlsruher-pass.de/wp-json/wp/v2/posts?categories_exclude=1922&_embed`
      } else {
        var categorieString = this.categoriesIDs.join();
        url = `https://karlsruher-pass.de/wp-json/wp/v2/posts?per_page=${this.perPage}&page=${this.currentPage}&categories[terms]=${categorieString}&categories[operator]=AND&_embed`;
       // url = `https://karlsruher-pass.de/wp-json/wp/v2/posts?per_page=${this.perPage}&page=${this.currentPage}&categories=${categorieString}&categories_exclude=1922,1817&_embed`;
        //    url = `https://karlsruher-pass.de/wp-json/wp/v2/posts?categories=${categorieString}&categories_exclude=1922&_embed`
      }
      try {
        this.isLoading = true;
        const response = await axios.get(url);
        const data = response.data;
        //   console.log("data")
        //   console.log(data)
        this.totalRows = response.headers["x-wp-total"];
        this.totalPages = response.headers["x-wp-totalpages"];
        data.forEach((element) => {
          // Hier werden alle IDs die in categorieIDs enthalten sind verglichen mit element.categories. Ein neues Array mit gefundenen IDs kommt zurück.
          var x = _.intersection(this.categoriesIDs, element.categories);

          if (JSON.stringify(x) == JSON.stringify(this.categoriesIDs)) {
            this.posts.push(element);
            //   console.log(element, "ele in if")
            //   console.log(this.posts, "posts")
          }
        });
        this.isLoading = false;
        this.tableIsBusy = false;
        //   console.log("after that ")
        //  console.log(this.posts);
      } catch (error) {
        throw error;
      }
    },

    checkContainCategorie(categorieArray) {
      categorieArray.forEach((el) => {});
    },
  },

  components: {
    Selects,
    AngTabelle,
  },
};
</script>


<style >
#Header {
  padding-bottom: 480px;
}

.table-responsive {
  overflow: hidden !important;
}

table th {
  background: unset !important;
  background-color: #fbb500;
  color: #c80029;
  border: 0;
}

th.table-stjawhite {
  background-color: #ffd965 !important;
}

.col-pagination {
  padding-left: 0;
}

.row-select {
  margin: 0;
}

.b-table-details {
  background-color: white;
}

.card {
  border: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

button.page-link.flex-grow-1 {
  background-color: #ffffff !important;
  margin: 0;
  border: 1px solid #dee2e6;
  height: max-content !important;
  width: unset;
}

button.page-link.flex-grow-1:hover {
  background-color: #e9ecef !important;
  color: #d52036 !important;
}

.page-item.active .page-link {
  border-color: #d52036 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/TableWrapper.vue